<template>
    <div>
        <div class="mb-30px mb-md-40px">
            <v-tabs show-arrows grow class="tab tab--block">
                <v-tab @click="select('closeAndOpen')">종료된 이벤트</v-tab>
                <v-tab @click="select('winner')">당첨자 발표</v-tab>
            </v-tabs>
        </div>
        <div class="my-md-n10px">
            <v-row>
                <v-col cols="6" md="3" v-for="board in boards" :key="board._id">
                    <div class="py-md-10px cursor-pointer event-card" @click="rows(board)">
                        <div class="border">
                            <v-card tile flat :img="board.thumb" max-width="500" class="event-card__image">
                                <v-responsive :aspect-ratio="255/180"></v-responsive>
                            </v-card>
                        </div>
                        <div class="text-center py-12px py-md-16px">
                            <div class="font-size-14 font-size-md-16 font-weight-bold text-truncate" >{{ board.subject }}</div>
                            <div class="font-size-12 font-size-md-14 mt-6px">{{ `${$dayjs(board.display.startDate).format("YYYY.MM.DD")} ~ ${board.display.endDate ? $dayjs(board.display.endDate).format("YYYY.MM.DD") : "상시진행"}` }}</div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
        <!-- <div>
            <v-data-table :items="boards" :headers="headers" disable-pagination disable-sort hide-default-footer :items-per-page="-1" mobile-breakpoint="768" class="v-data-table--default" @click:row="rows">
                <span slot="item.no" slot-scope="{item}">
                    <v-icon v-if="item.isNotice" color="yellow darken-2">mdi-alert-circle-outline</v-icon>
                    <span v-else>{{ (page - 1) * limit + +boards.filter(noti => !noti.isNotice).indexOf(item) + 1 }}</span>
                </span>
                <span slot="item.subject" slot-scope="{item}" class="d-block font-weight-medium text-truncate">
                    <v-row>
                        <v-col cols="auto" class="pr-1">{{ item.subject }}</v-col>
                        <v-col v-if="item.isComment" class="pl-1">({{ item.commentCount }})</v-col>
                    </v-row>
                </span>
                <span slot="item.writer.name">관리자</span>
                <span slot="item.createdAt" slot-scope="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
            </v-data-table>
        </div> -->

        <div class="mt-30px mt-md-40px">
            <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search(true)"/>
        </div>

        <!-- <div class="mt-30px mt-md-40px">
            <v-divider />
            <div class="grey lighten-4 pa-12px py-md-20px">
                <div class="mw-500px mx-auto">
                    <v-row align="center" class="row--x-small">
                        <v-col cols="12" md="auto">
                            <v-select v-model="filter.searchKey" :items="searchKeyItems" item-text="text" item-value="value" outlined hide-details dense class="white mw-md-180px" @input="value => filter.searchValue = value ? filter.searchValue : ''"/>
                        </v-col>
                        <v-col cols="12" md="">
                            <v-row align="center" class="row--x-small">
                                <v-col>
                                    <v-text-field v-model="filter.searchValue" outlined hide-details class="white" :disabled="!filter.searchKey"/>
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn @click="$emit('search', false )" color="primary" class="v-btn--input w-80px">검색</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </div>
            </div>
            <v-divider />
        </div> -->
    </div>
</template>

<script>
import api from "@/api";
export default {
    props: {
        boards: { type: Array, default: [] },
        summary: { type: Object },
		filter: { type: Object }
    },
    data(){
        return {
            page: this.$attrs.page || 1,
            pageCount: Math.ceil((this.$props?.summary?.totalCount || 0) / this.$attrs.limit) || 0,
            skip: this.$attrs.skip || 0,
            limit: this.$attrs.limit || 10,

            headers: [
                { text: "No", value: "no", align: "center", width: "8%" },
                { text: "제목", value: "subject", align: "left", width: "64%" },
				{ text: "작성자", value: "writer.name", align: "center", width: "14%" },
                { text: "작성일자", value: "createdAt", align: "center", width: "14%" },
            ],

			searchKeyItems: [
				{ text: ":: 검색조건 ::", value: "" },
				{ text: "제목", value: "subject" },
				{ text: "내용", value: "content" },
				{ text: "제목+내용", value: "subject+content" },
				// { text: "작성자", value: "writer.name" },
				{ text: "아이디", value: "writer.username" },
			]
        }
    },
    methods: {
        rows(board) {
            if(board?.url) {
                this.$router.push(board?.url)
            } else {
                this.$router.push(`/board/event/${board?._id}`)
            }
        },
        select(status) {
            this.filter.status = status
            this.$emit("search", false)
        }
    }
}
</script>

<style scoped>
@media (max-width:1024px){
}
@media (max-width:992px){
}
@media (max-width:600px){
    >>>.v-data-table--default table >tbody >tr >*:nth-child(1){display:none !important;}
    >>>.v-data-table--default table >tbody >tr >*:nth-child(3),
    >>>.v-data-table--default table >tbody >tr >*:nth-child(4){
        display: inline-block !important;
        border-bottom: none !important;
    }
    >>>.v-data-table .v-data-table__mobile-table-row>.v-data-table__mobile-row:last-child{
        border-bottom: none !important;
    }
    >>>.v-data-table--default>.v-data-table__wrapper>table>tbody>tr{
        border-bottom:1px solid #bdbdbd !important;
    }
}
@media (max-width:576px){
}
</style>